module.exports = __webpack_public_path__ + "media/images/logo-77721f953b7f6d203d7a4e1d3c093e13.png";